import { useState, useEffect } from 'react';
import { retainersAPI } from '../../utils/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';

export const EditMonthDialog = ({ month, onClose, onSaved }) => {
  const [dueDate, setDueDate] = useState('');
  const [amount, setAmount] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (month) {
      setDueDate(month.due_date || '');
      setAmount(month.amount?.toString() || '');
    }
  }, [month]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await retainersAPI.updateMonth(month.id, { due_date: dueDate, amount: parseFloat(amount) });
      toast.success(`${month.month_label} updated`);
      onClose();
      onSaved();
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Failed to update month');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!month} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="edit-month-dialog">
        <DialogHeader>
          <DialogTitle>Edit {month?.month_label}</DialogTitle>
          <DialogDescription>Change the due date or amount for this month only.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Due Date</Label>
            <Input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required data-testid="edit-month-due-input" />
          </div>
          <div className="space-y-2">
            <Label>Amount (INR)</Label>
            <Input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} required data-testid="edit-month-amount-input" />
          </div>
          <div className="flex gap-2 justify-end pt-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="edit-month-cancel">Cancel</Button>
            <Button type="submit" disabled={saving} data-testid="edit-month-submit">{saving ? 'Saving...' : 'Save'}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
